// extracted by mini-css-extract-plugin
export var animationContainer = "_hr-0";
export var footer = "_hr-1";
export var gray = "_hr-2";
export var lineItem = "_hr-3";
export var lineItemImage = "_hr-4";
export var lineItemInfo = "_hr-5";
export var lineItemText = "_hr-6";
export var lineItems = "_hr-7";
export var modalContent = "_hr-8";
export var options = "_hr-9";
export var orderName = "_hr-a";
export var refundAmount = "_hr-b";